import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const authService = inject(AuthService);
    const token = authService.getToken();

    // Public client-form endpoints — never attach Bearer or trigger logout
    const isClientFormRequest = req.url.includes('/api/client/');
    const isClientUpload = isClientFormRequest && req.url.includes('upload_signed');

    // Clone the request and add the authorization header if the token exists
    if (token && !isClientFormRequest && !isClientUpload) {
        req = req.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`
            }
        });
    }

    return next(req).pipe(
        catchError((error: HttpErrorResponse) => {
            if (error.status === 401 && !isClientFormRequest && !isClientUpload) {
                // Auto logout if 401 response returned from api
                authService.logout();
            }
            return throwError(() => error);
        })
    );
};
